interface BundleSplitColorSwatchProps {
  colors: string[];
  className?: string;
}

export const BundleSplitColorSwatch = ({ colors, className = "w-7 h-7" }: BundleSplitColorSwatchProps) => {
  if (colors.length === 0) return null;
  
  if (colors.length === 1) {
    return (
      <div
        className={`${className} rounded-full`}
        style={{ backgroundColor: colors[0] }}
      />
    );
  }

  return (
    <div
      className={`${className} rounded-full`}
      style={{
        background: `linear-gradient(to right, ${colors[0]} 50%, ${colors[1]} 50%)`,
      }}
    />
  );
};
